import { Injectable } from '@angular/core';
import {MessageBase} from './message-base';
import {Observable, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';
interface DoraMessage {
  channel: string;
  type: string;
  callerId: string; // ID of class that call the service.
  // @ts-ignore
  data: MessageBase;
}
@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private subject: Subject<DoraMessage>;

  constructor() {
    this.subject = new Subject<DoraMessage>();
  }

  /**
   * Send Message/Event
   * @param channel Channel ID
   * @param data Message to send
   * @param callerId Caller ID. It's necessary to not allow to send message to myself
   */
  // @ts-ignore
  sendMessage(channel: string = '1', data: MessageBase, callerId: string): void {
    this.subject.next({channel, type: data.type, callerId, data });
  }

  clearMessage() {
    this.subject.next();
  }

  /**
   * Get observable to subscribe to get specific Message/Event
   * @param channel Channel ID
   * @param messageType Message type to read
   * @param callerId Caller ID. It's necessary to not allow to send message to myself
   */
  getMessage<T>(channel: string = '1', messageType: { new(...args: any[]): T }, callerId: string): Observable<DoraMessage> {
    const messageTypeString: string = (messageType as any).name;
    return this.subject.pipe(filter((m: DoraMessage) =>
        m.channel === channel && m.data.type === messageTypeString && m.callerId !== callerId));
  }
}
